import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import Table from "../../../Components/Table";
import {
    ListarExecucoesManuaisETLController,
    VoltarDataETLController,
} from "../../../Controllers/Geral/ExecutarETL/ExecutarETLController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IExecutarETL } from "../../../Interfaces/Geral/ExecutarETL/ExecutarETLInterface";

export default function ExecutarETL() {
    const {
        value: lstExecucoesManuaisEtl,
        loading: lstExecucoesManuaisEtlLoading,
        execute: ListarExecucoesManuaisETL,
    } = useAsyncEffect(() => ListarExecucoesManuaisETLController());

    const { execute: VoltarDataETL, loading: VoltarDataETLLoading } =
        useAsyncCallback(VoltarDataETLController);

    const columns: Array<ColumnDescription<IExecutarETL>> = [
        {
            dataField: "DS_NOME",
            text: "Usuário responsável",
            classes: "p-3 ws-nowrap align-middle text-center",
            headerAlign: "center",
        },
        {
            dataField: "DT_EXECUCAO",
            text: "Data de execução",
            classes: "p-3 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (_, row) => {
                return <>{moment(row.DT_EXECUCAO).format("LLL")}</>;
            },
        },
    ];

    return (
        <div className="d-flex justify-content-center card card-body">
            <h1 className="text-center">ETL - IMPORTAR DADOS</h1>
            <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                    <h3 className="d-flex align-items-end">
                        Últimas importações manuais
                    </h3>
                    <button
                        className="btn btn-primary my-6"
                        onClick={() => {
                            VoltarDataETL().then(() => {
                                ListarExecucoesManuaisETL();
                            });
                        }}
                        disabled={VoltarDataETLLoading}
                    >
                        Executar ETL{" "}
                        {VoltarDataETLLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faPlay} className="ml-1" />
                        )}
                    </button>
                </div>
                <Table
                    columns={columns}
                    data={lstExecucoesManuaisEtl ?? []}
                    loading={lstExecucoesManuaisEtlLoading}
                    keyField="ID_ETL_LOG_USUARIO"
                    noSearch
                />
            </div>
        </div>
    );
}
